import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { AppConfig } from "../../providers/config";
import { InsurersProvider } from '../../providers/insurers/insurers';

@IonicPage()
@Component({
  selector: 'page-program-insurers-add',
  templateUrl: 'program-insurers-add.html',
})
export class ProgramInsurersAddPage {

  program_id: string;
  program_name: string;
  user: any;
  provinces = AppConfig.Global.provinces;

  page_name: string;
  insurer: any;
  existing = false;

  insurerForm: FormGroup; 

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private auth: AuthProvider,
    private insurersProvider: InsurersProvider,
    private fb: FormBuilder) {
    
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      this.program_name = user.program_name;
      this.program_id = user.program_id;
    });

    if (this.navParams.get('insurerdata')) {
      this.insurer = this.navParams.get('insurerdata')
      //console.log('Existin Pharmacy: ', this.pharmacy);
      this.page_name = 'Edit ' + this.insurer.name;
      this.insurerForm.patchValue(this.insurer);
      this.existing = true;
    } else {
      this.insurer = null;
      this.page_name = 'Add Payer';
      this.existing = false;
    }
  }

  createForm()  {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/
    let cellfaxregex: RegExp = /^\+[1-9]\d{1,14}$/

    this.insurerForm = this.fb.group({
      'name': [null, [Validators.required]],
      'type': [null, [Validators.required]],
      'fax_number': [null, [Validators.required, Validators.pattern(cellfaxregex)]],
      'phone_number': [null, [Validators.required, Validators.pattern(phoneregex)]],
      'address': [null, [Validators.required]],
      'address2': [null],
      'city': [null, [Validators.required]],
      'province': [null, [Validators.required]],
      'postal_code': [null, [Validators.required]],
      'main_contact_name': [null],
      'main_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'main_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'main_contact_email': [null, [Validators.pattern(emailregex)]],
      'alt_contact_name': [null],
      'alt_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'alt_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'alt_contact_email': [null, [Validators.pattern(emailregex)]],
    });
  }

  saveInsurer() {
    const insurer = this.insurerForm.value;
    if (this.existing) {
      this.insurersProvider.updateInsurer(this.program_id, this.insurer.id, insurer, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    } else {
      this.insurersProvider.addInsurer(this.program_id, insurer, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    }
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-insurers-add/program-insurers-add.ts